import { WORKOUT_KEY } from '../../../../../modules/workout/model'
import { WORKOUT_SECTION_KEY } from '../../../../workout-section/model'
import updateReduxAction from '../../../../redux/actions/update'
import createPointerReduxUtil from '../../../../redux/utils/create-pointer'
import { getIdReduxUtil } from '../../../../redux/utils/get-id'
import getInstanceReduxUtil from '../../../../redux/utils/get-instance'
import { getPathReduxUtil } from '../../../../redux/utils/get-path'
import { getValueReduxUtil } from '../../../../redux/utils/get-value'
import { saveWorkoutSectionAction } from '../../../../workout-section/redux/actions/save'
import WORKOUTS_ACTION from '../../constants/action'
import getCurrentOrStartedWorkoutSelect from '../../selectors/get-current-or-started'

function updateWorkoutSectionsOrderWorkoutAction (workoutSectionPointers) {
  return async (dispatch, getState) => {
    const updates = []
    let shouldUpdate = false
    workoutSectionPointers.forEach((workoutSectionPointer, index) => {
      const workoutSection = getInstanceReduxUtil(
        getState(),
        workoutSectionPointer
      )
      const order = index + 1
      updates.push({
        [WORKOUT_SECTION_KEY.ORDER]: order
      })
      if (getValueReduxUtil(workoutSection, WORKOUT_SECTION_KEY.ORDER) !==
        order) {
        shouldUpdate = true
      }
    })
    if (!shouldUpdate) {
      return
    }
    const workout = getCurrentOrStartedWorkoutSelect(getState())
    // Delete the workout section from the Workout
    dispatch(updateReduxAction({
      type: WORKOUTS_ACTION.UPDATE_WORKOUT_SECTIONS_ORDER,
      payload: {
        paths: [
          getPathReduxUtil(workout),
          ...workoutSectionPointers.map(getPathReduxUtil)
        ],
        updates: [
          {
            [WORKOUT_KEY.WORKOUT_SECTIONS]: (
              workoutSectionPointers.map(createPointerReduxUtil)
            )
          },
          ...updates
        ]
      }
    }))
    return Promise.all(workoutSectionPointers.map(workoutSectionPointer => {
      return dispatch(saveWorkoutSectionAction(getIdReduxUtil(
        workoutSectionPointer)))
    }))
  }
}

export default updateWorkoutSectionsOrderWorkoutAction
